import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowRunSourceAdditionFailedAction = {
	type: 'WORKFLOW_RUN_SOURCE_ADDITION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowRunSourceAdditionFailedAction => ({
	type: 'WORKFLOW_RUN_SOURCE_ADDITION_FAILED',
	payload,
});
